import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { ICompsViewerState, GeoJsonPolygon } from '../../types';
import { ComparableMarker } from './components/ComparableMarker';
import { SubjectMarker } from './components/SubjectMarker';
import { SubjectCard } from './components/SubjectCard';
import { SubjectPolygon } from './components/SubjectPolygon';
import { exportComparablesToExcel } from './utils/exportComparablesToExcel';
import { MapWrapper, ResetButton, DownloadButton } from './styles';

interface CompsMapProps {
  data: ICompsViewerState;
  onReset: () => void;
}

const DEFAULT_CENTER: [number, number] = [4.624335, -74.063644];

const getValidPolygon = (raw: unknown): GeoJsonPolygon | null => {
  if (
    raw === null ||
    raw === undefined ||
    Array.isArray(raw) ||
    typeof raw !== 'object'
  ) return null;

  const geo = raw as GeoJsonPolygon;
  if (!Array.isArray(geo.coordinates) || geo.coordinates.length === 0) return null;
  if (!Array.isArray(geo.coordinates[0]) || geo.coordinates[0].length === 0) return null;

  return geo;
};

export const CompsMap = ({ data, onReset }: CompsMapProps) => {
  const { nid, subjectLat, subjectLng, rows } = data;
  const validPolygon = getValidPolygon(rows[0]?.poligono);

  const mappableRows = rows.filter(
    row => row.comparable.latitude != null && row.comparable.longitude != null
  );

  const firstRowCenter: [number, number] = mappableRows.length > 0
    ? [mappableRows[0].comparable.latitude as number, mappableRows[0].comparable.longitude as number]
    : DEFAULT_CENTER;

  const mapCenter: [number, number] =
    subjectLat != null && subjectLng != null
      ? [subjectLat, subjectLng]
      : firstRowCenter;

  return (
    <MapWrapper>
      <MapContainer
        center={mapCenter}
        zoom={15}
        zoomControl={false}
        style={{ width: '100%', height: '100%' }}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        <ZoomControl position="bottomright" />

        {validPolygon && <SubjectPolygon poligono={validPolygon} />}

        {mappableRows.map((row, idx) => (
          <ComparableMarker
            key={row.historico_pricing_comparable_id ?? idx}
            row={row}
            index={idx}
          />
        ))}

        <SubjectMarker lat={subjectLat} lng={subjectLng} nid={nid} />
      </MapContainer>

      <SubjectCard
        nid={nid}
        lat={subjectLat}
        lng={subjectLng}
        askPrice={rows[0]?.ask_price_habi ?? null}
        askPriceM2={rows[0]?.ask_price_habi_m2 ?? null}
        percentil={rows[0]?.percentil ?? null}
        comparablesCount={mappableRows.length}
        hasPolygon={!!validPolygon}
      />

      <ResetButton onClick={onReset}>← Nueva consulta</ResetButton>

      <DownloadButton
        onClick={() => exportComparablesToExcel(rows, nid)}
        disabled={rows.length === 0}
        title="Descargar comparables en Excel"
      >
        ↓ Descargar Excel
      </DownloadButton>
    </MapWrapper>
  );
};
